// extracted by mini-css-extract-plugin
export var attachment = "_mx-a";
export var emailContainer = "_mx-4";
export var emailContentPaddedContainer = "_mx-b";
export var emailHeader = "_mx-6";
export var emailIframe = "_mx-3";
export var emailInfoIcon = "_mx-9";
export var emailShortenedSummary = "_mx-e";
export var infoDropdown = "_mx-0";
export var infoRowBoundedContent = "_mx-d";
export var internal = "_mx-5";
export var merchant = "_mx-8";
export var messageInputContainer = "_mx-h";
export var normal = "_mx-7";
export var replyCard = "_mx-f";
export var subtleButton = "_mx-1";
export var subtleButtonIconContainer = "_mx-2";
export var toggleViewRepliesButton = "_mx-c";
export var wrappingText = "_mx-g";